import { render, staticRenderFns } from "./AppTable.vue?vue&type=template&id=1a8d5f1e"
import script from "./AppTable.vue?vue&type=script&lang=ts"
export * from "./AppTable.vue?vue&type=script&lang=ts"
import style0 from "./AppTable.vue?vue&type=style&index=0&id=1a8d5f1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports